import { Component } from "@angular/core";

import { rotateInDownLeftAnimation } from "angular-animations";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { CarouselTestimonialsComponent } from "../../../shared/carousel-testimonials/carousel-testimonials.component";
import { testimonials } from "../../../shared/Testimonials";
import { type TestimonialConfig } from "../../../shared/testimonial-card/testimonial-card.component";

@Component({
  selector: "app-why",
  templateUrl: "./why.component.html",
  styleUrls: ["./why.component.scss"],
  imports: [SlickCarouselModule, CarouselTestimonialsComponent],
  animations: [rotateInDownLeftAnimation()],
})
export class WhyComponent {
  public readonly testimonialsConfigCarousel: TestimonialConfig[] =
    testimonials;
}
